import React, { useEffect, useState } from "react";
import { 
  Box, 
  Container, 
  Typography, 
  Button,
  Breadcrumbs,
  Link,
  Alert
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import FamilyTreeTab from "../FamilyTreeTab"; // Reusing the core logic component
import { useAuth } from "../../../firebase";

// Reuse the background logic or create a layout component
const BG_IMAGE = "https://media.rainpos.com/663/hex5f021f_burgundy_design_swirl_boldtiny09867633333333.jpg";

const FamilyTreeStudioPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const [order, setOrder] = useState<any>(null);
  const [loading, setLoading] = useState(!!orderId);

  useEffect(() => {
     if (orderId) {
        const fetchOrder = async () => {
           try {
             // We need to import db and doc/getDoc here if not already available in closure, 
             // but assuming we can add imports or they exist. 
             // EDIT: better to ensure imports are present.
             const { doc, getDoc } = await import("firebase/firestore");
             const { db } = await import("../../../firebase");
             
             const snap = await getDoc(doc(db, "orders", orderId));
             if (snap.exists()) setOrder(snap.data());
           } catch (e) { console.error(e); }
           finally { setLoading(false); }
        };
        fetchOrder();
     }
  }, [orderId]);
  
  const requiredGens = order?.items?.[0]?.selectedOptions?.generations || 0;
  
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Studio Header (Slim) */}
      <Box sx={{ 
        height: "60px",
        backgroundImage: `url('${BG_IMAGE}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        color: "white",
        pl: 0
      }}>
        <Container maxWidth="xl" sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Button 
              startIcon={<ArrowBack />} 
              sx={{ color: "white", opacity: 0.9, minWidth: 'auto' }}
              onClick={() => navigate(orderId ? `/account/orders/${orderId}` : "/account")}
            >
              Back
            </Button>
            <Typography variant="h6" sx={{ fontFamily: '"Playfair Display", serif' }}>
              Family Tree Editor
            </Typography>
        </Container>
      </Box>

      {/* Main Workspace */}
      <Box sx={{ flexGrow: 1, bgcolor: "#f5f5f5", p: 3 }}>
        <Container maxWidth="xl">
          {orderId && (
            <Alert severity="info" sx={{ mb: 3 }}>
              Editing Family Tree for Order <strong>#{orderId}</strong>. 
              {requiredGens > 0 && (
                  <span> You purchased a <strong>{requiredGens}-Generation</strong> chart. Please ensure you have ancestors filled out up to that level.</span>
              )}
            </Alert>
          )}

          {/* Render the original complex logic component */}
          {/* We might want to refactor FamilyTreeTab to NOT include its own paper/padding if it conflicts */}
          <FamilyTreeTab />
        </Container>
      </Box>
    </Box>
  );
};

export default FamilyTreeStudioPage;
